var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircledPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.25c.38 0 .7.28.74.65l.01.1v3.25H16a.75.75 0 01.1 1.5h-3.35V16a.75.75 0 01-1.5.1v-3.35H8a.75.75 0 01-.1-1.5h3.35V8c0-.41.34-.75.75-.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25h-.28A9.75 9.75 0 002.25 12v.28A9.75 9.75 0 0012 21.75h.28A9.75 9.75 0 0021.75 12v-.28A9.75 9.75 0 0012 2.25zm-.24 1.5H12a8.25 8.25 0 018.25 8v.26c0 4.46-3.55 8.1-8 8.24h-.26a8.25 8.25 0 01-8.24-8v-.26c0-4.46 3.55-8.1 8-8.24z"
  })));
}
export default SvgCircledPlus;